import jsnes from "jsnes";

// 屏幕宽度
const SCREEN_WIDTH = 256;
// 屏幕高度
const SCREEN_HEIGHT = 240;
const FRAMEBUFFER_SIZE = SCREEN_WIDTH * SCREEN_HEIGHT;

/**
 * 创建 JSNES 实例
 * @param canvasId 画布 ID
 * @returns
 */
Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt
};
export default {

    createNes(canvasId) {
        // init
        const canvas = document.getElementById(canvasId);
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            console.log("画布不存在");
            return;
        }
        const imageData = ctx.getImageData(0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);

        ctx.fillStyle = "black";
        ctx.fillRect(0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);

        // Allocate framebuffer array.
        const buffer = new ArrayBuffer(imageData.data.length);
        const framebuffer_u8 = new Uint8ClampedArray(buffer);
        const framebuffer_u32 = new Uint32Array(buffer);

        // Setup audio.
        const AUDIO_BUFFERING = 512;
        const audioCtx = new window.AudioContext();
        const script_processor = audioCtx.createScriptProcessor(
            AUDIO_BUFFERING,
            0,
            2
        );
        script_processor.onaudioprocess = audio_callback;
        script_processor.connect(audioCtx.destination);

        const SAMPLE_COUNT = 4 * 1024;
        const SAMPLE_MASK = SAMPLE_COUNT - 1;
        const audio_samples_L = new Float32Array(SAMPLE_COUNT);
        const audio_samples_R = new Float32Array(SAMPLE_COUNT);

        let audio_write_cursor = 0;
        let audio_read_cursor = 0;

        var nes = new jsnes.NES({
            onFrame(framebuffer_24) {
                for (let i = 0; i < FRAMEBUFFER_SIZE; i++)
                    framebuffer_u32[i] = 0xff000000 | framebuffer_24[i];
            },
            onAudioSample(l, r) {
                audio_samples_L[audio_write_cursor] = l;
                audio_samples_R[audio_write_cursor] = r;
                audio_write_cursor = (audio_write_cursor + 1) & SAMPLE_MASK;
            },
        });
        var db = this.dbtool()

        function onAnimationFrame() {
            if (!ctx) {
                return;
            }

            window.requestAnimationFrame(onAnimationFrame);

            imageData.data.set(framebuffer_u8);
            ctx.putImageData(imageData, 0, 0);
        }

        function audio_remain() {
            return (audio_write_cursor - audio_read_cursor) & SAMPLE_MASK;
        }

        function audio_callback(event) {
            const dst = event.outputBuffer;
            const len = dst.length;

            // Attempt to avoid buffer underruns.
            if (audio_remain() < AUDIO_BUFFERING) nes.frame();

            let dst_l = dst.getChannelData(0);
            let dst_r = dst.getChannelData(1);
            for (let i = 0; i < len; i++) {
                const src_idx = (audio_read_cursor + i) & SAMPLE_MASK;
                dst_l[i] = audio_samples_L[src_idx];
                dst_r[i] = audio_samples_R[src_idx];
            }

            audio_read_cursor = (audio_read_cursor + len) & SAMPLE_MASK;
        }

        return {
            /**
             * 绑定按钮
             * @param button
             * @returns
             */
            bindButton(name) {
                const buttonName = "BUTTON_" + name;
                const btn = document.querySelector(
                    `[role="${buttonName}"]`
                );
                if (!btn) {
                    return;
                }

                const onButtonDown = () => {
                    nes.buttonDown(1, jsnes.Controller[buttonName]);
                };

                const onButtonUp = () => {
                    nes.buttonUp(1, jsnes.Controller[buttonName]);
                };

                btn.ontouchstart = onButtonDown;
                btn.onmousedown = onButtonDown;
                btn.ontouchend = onButtonUp;
                btn.onmouseup = onButtonUp;
            }
            ,
            bindButton2() {
                document.addEventListener('keydown', (event) => {
                    // this.keyboard(nes.buttonDown, event)
                    console.log(event.key);
                    if (event.key == "w") {
                        nes.buttonDown(1, jsnes.Controller.BUTTON_UP);
                    }
                    if (event.key == "s") {
                        nes.buttonDown(1, jsnes.Controller.BUTTON_DOWN);
                    }
                    if (event.key == "a") {
                        nes.buttonDown(1, jsnes.Controller.BUTTON_LEFT);
                    }
                    if (event.key == "d") {
                        nes.buttonDown(1, jsnes.Controller.BUTTON_RIGHT);
                    }
                    if (event.key == "u") {
                        nes.buttonDown(1, jsnes.Controller.BUTTON_START);
                    }
                    if (event.key == "i") {
                        nes.buttonDown(1, jsnes.Controller.BUTTON_SELECT);
                    }
                    if (event.key == "j") {
                        nes.buttonDown(1, jsnes.Controller.BUTTON_A);
                    }
                    if (event.key == "k") {
                        nes.buttonDown(1, jsnes.Controller.BUTTON_B);
                    }
                });
                document.addEventListener('keyup', (event) => {
                    if (event.key == "w") {
                        nes.buttonUp(1, jsnes.Controller.BUTTON_UP);
                    }
                    if (event.key == "s") {
                        nes.buttonUp(1, jsnes.Controller.BUTTON_DOWN);
                    }
                    if (event.key == "a") {
                        nes.buttonUp(1, jsnes.Controller.BUTTON_LEFT);
                    }
                    if (event.key == "d") {
                        nes.buttonUp(1, jsnes.Controller.BUTTON_RIGHT);
                    }
                    if (event.key == "u") {
                        nes.buttonUp(1, jsnes.Controller.BUTTON_START);
                    }
                    if (event.key == "i") {
                        nes.buttonUp(1, jsnes.Controller.BUTTON_SELECT);
                    }
                    if (event.key == "j") {
                        nes.buttonUp(1, jsnes.Controller.BUTTON_A);
                    }
                    if (event.key == "k") {
                        nes.buttonUp(1, jsnes.Controller.BUTTON_B);
                    }
                });
            },
            save(romName) {
                console.log(db);
                let nesj = nes.toJSON();
                nesj.name = romName;
                // if (dbid) {
                //     nesj.id = dbid
                // }
                let canvas = document.getElementById("nes-canvas");
                let nesInfo = new Object();
                nesInfo.name = romName + 'info';
                nesInfo.pic = canvas.toDataURL("image/jpeg", 0.2);
                nesInfo.time = new Date().Format("yyyy-MM-dd hh:mm:ss");
                console.log(nesInfo);
                db.saveDateCall(nesj, nesInfo, romName+"1", function (id1, id2) {
                    console.log(id1);
                    console.log(id2);
                })

            }
            ,
            sload(romName,fcc) {
                let _this=this;
                db.loadDataCall(6, function (d) {
                    console.log(romName);
                    console.log(d);
                    if (d) {
                        console.log(nes);
                        nes.fromJSON(d);
                        // nes.frame()
                    }
                })
                // nes.frame()
                // nes.fromJSON(decodedData);
            }
            ,
            /**
             * 加载 ROM
             * @param url 路径
             */
            async load(url) {
                const req = new XMLHttpRequest();
                req.open("GET", url);
                req.overrideMimeType("text/plain; charset=x-user-defined");
                req.onload = () => {
                    if (req.status === 200) {
                        this.boot(req.responseText);
                    } else if (req.status === 0) {
                        // Aborted, so ignore error
                    } else {
                        console.log(`Error loading ${url}: ${req.statusText}`);
                    }
                };
                req.send();
            }
            ,

            /**
             * 启动 ROM
             * @param rom_data
             */
            boot(rom_data) {
                nes.loadROM(rom_data);

                window.requestAnimationFrame(onAnimationFrame);

            }
            ,
        }
            ;
    },
    dbtool() {
        var fcdb = null;
        var storeName = 'nesjson';
        return {

            saveDate(args) {
                var tranJson = fcdb.transaction(storeName, 'readwrite');
                var addNesJsons = tranJson.objectStore(storeName).put(args[0]);
                addNesJsons.onsuccess = function (e) {
                    var nesJsonid = e.target.result;
                    args[1].nesid = nesJsonid;
                    if (args[2]) {
                        args[1].id = args[2]
                    }
                    var addNesInfo = tranJson.objectStore(storeName).put(args[1]);
                    addNesInfo.onsuccess = function (e) {
                        args[3](nesJsonid, e.target.result)
                    }
                };
            },
            saveDateCall() {
                this.operate(arguments, this.saveDate)
            },
            operate(args, operateFun) {
                if (fcdb) {
                    operateFun(args)
                } else {
                    var request = window.indexedDB.open("fcdata");
                    request.onerror = function (e) {
                        console.log('open Error!')
                    };
                    request.onsuccess = function (e) {
                        fcdb = e.target.result;
                        operateFun(args)
                    };
                    request.onupgradeneeded = function (e) {
                        var db = e.target.result;
                        if (!db.objectStoreNames.contains(storeName)) {
                            try {
                                var objectStore = db.createObjectStore(storeName, {keyPath: 'id', autoIncrement: true});
                                objectStore.createIndex('nameIndex', 'name', {unique: false})
                            } catch (e) {
                                console.log(e)
                            }
                        }
                    }
                }
            },
            loadData(args) {
                var transaction = fcdb.transaction(storeName);
                var objectStore = transaction.objectStore(storeName);
                var getrequest = objectStore.get(args[0]);
                getrequest.onsuccess = function (event) {
                    if (event.target.result) {
                        args[1](event.target.result)
                    }
                }
            },
            loadDataCall() {
                this.operate(arguments, this.loadData)
            },
            getNesList(args) {
                var transaction = fcdb.transaction(storeName);
                var store = transaction.objectStore(storeName);
                var index = store.index("nameIndex");
                var request = index.openCursor(IDBKeyRange.only(args[0]));
                var nesList = [];
                request.onsuccess = function (e) {
                    var cursor = e.target.result;
                    var isEnd = true;
                    if (cursor) {
                        var nesInfo = cursor.value;
                        nesList.push(nesInfo);
                        isEnd = false;
                        cursor.continue()
                    }
                    if (isEnd) {
                        args[1](nesList)
                    }
                }
            },
            getNesListCall() {
                this.operate(arguments, this.getNesList)
            },
            deleteData(args) {
                var transaction = fcdb.transaction(storeName, 'readwrite');
                transaction.objectStore(storeName).delete(args[0]);
                transaction.objectStore(storeName).delete(args[1]);
                transaction.oncomplete = function (event) {
                    args[2]()
                }
            },
            deleteDataCall() {
                this.operate(arguments, this.deleteData)
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/fcc.js